import React, { FC } from "react";

import "./link-list.css";
import { MailFilled, WhatsAppOutlined } from "@ant-design/icons";

type Icon = "mail" | "phone";

export type Item = {
  text: string;
  link?: string;
  icon?: Icon;
  callback?: () => void;
};

export interface LinkListProps {
  title: string;
  linkList: Item[];
}

function renderIcon(icon?: Icon) {
  if (icon == undefined) {
    return <></>;
  }
  switch (icon) {
    case "mail":
      return (
        <span className="xvia-link-list__icon">
          <MailFilled style={{ color: "white" }} />
        </span>
      );
    case "phone":
      return (
        <span className="xvia-link-list__icon">
          <WhatsAppOutlined style={{ color: "white" }} />
        </span>
      );
  }
}

function renderItem(item: Item) {
  const content = (
    <>
      {renderIcon(item.icon)}
      {item.text}
    </>
  );

  if (item.callback) {
    return (
      <button
        type="button"
        onClick={item.callback}
        className={"xvia-link-list__text"}
        style={{ background: "none", border: 0, padding: 0, cursor: "pointer" }}
      >
        {content}
      </button>
    );
  }

  if (item.link) {
    return (
      <a
        href={item.link}
        target={"_blank"}
        className={"xvia-link-list__text"}
        rel="noreferrer"
      >
        {content}
      </a>
    );
  }

  return content;
}

export const LinkList: FC<LinkListProps> = ({ title, linkList }) => {
  return (
    <span className={"xvia-link-list"}>
      <span className="xvia-link-list__title">{title}</span>
      <div>
        <ul className={"xvia-link-list__ul"}>
          {linkList.map((item, index) => {
            return (
              <li key={item.link || `${item.text}-${index}`}>
                {renderItem(item)}
              </li>
            );
          })}
        </ul>
      </div>
    </span>
  );
};
